
import { useState } from "react";
import { useAuth } from "@/hooks/use-auth";
import { useAdminStatus } from "@/hooks/useAdminStatus";
import { NavigationHeader } from "./navigation/NavigationHeader";
import { DesktopNavigationLinks } from "./navigation/DesktopNavigationLinks";
import { MobileNavigationMenu } from "./navigation/MobileNavigationMenu";
import { getVisibleNavigationItems } from "./navigation/NavigationItems";

export function Navigation() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { user } = useAuth();
  const adminStatus = useAdminStatus();

  if (!user) return null;

  const visibleItems = getVisibleNavigationItems(adminStatus.isAdmin);

  const handleMenuToggle = () => {
    setMenuOpen(!menuOpen);
  };

  const handleMenuItemClick = () => {
    setMenuOpen(false);
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-md border-b">
      <div className="flex h-16 items-center px-4 md:px-6 max-w-full">
        {/* Logo - Fixed width on left */}
        <div className="flex-shrink-0 w-auto min-w-0">
          <NavigationHeader 
            onMenuToggle={handleMenuToggle}
            menuOpen={menuOpen}
          />
        </div>
        
        {/* Desktop navigation links - centered with proper spacing */}
        <div className="hidden md:flex flex-1 justify-center px-4 min-w-0">
          <DesktopNavigationLinks items={visibleItems} />
        </div>
        
        {/* Right side spacer for balance - matches logo width */}
        <div className="hidden md:block flex-shrink-0 w-auto min-w-0"></div>
      </div>

      <MobileNavigationMenu 
        items={visibleItems}
        menuOpen={menuOpen}
        onMenuItemClick={handleMenuItemClick}
      />
    </nav>
  );
}
